import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Apollo } from 'apollo-angular';
import moment from 'moment';
import { ClienteService } from 'src/app/services/cliente.service';
import { ConfirmacionService } from 'src/app/services/confirmacion.service';
import { DocAdicionalService } from 'src/app/services/doc-adicional.service';
import { EmailService } from 'src/app/services/email.service';
import { LoginService } from 'src/app/services/login.service';
import { AltaContratistaComponent } from './alta-contratista/alta-contratista.component';
import { SolicitudCentrosComponent } from './solicitud-centros/solicitud-centros.component';

@Component({
  selector: 'app-gestion',
  templateUrl: './gestion.component.html',
  styleUrls: ['./gestion.component.scss'],
})

export class GestionComponent implements OnInit {

userLog:any
docAdicional:any = []
documento:any
centrosCliente:any = []
caducidad:any
periodos:any = []
periodoSeleccionado:any
documentoAdicional:any
mailContratista:any = []
cliente:any
docFirstTime:any=[]
numArchivo:any

  constructor(
    public dialog: MatDialog, 
    private apollo: Apollo, 
    private clienteService: ClienteService, 
    private loginService: LoginService,
    private docAdicionalService: DocAdicionalService,
    private confirmacionService: ConfirmacionService,
    private formBuilder: FormBuilder,
    private mailService: EmailService) {

    this.userLog = loginService.getUserData()
    this.periodos = ['Mensual', 'Trimestral', 'Semestral', 'Anual', 'No Caduca'];
    this.buildForm();
  }

  private buildForm() {
    this.documentoAdicional = this.formBuilder.group({
      nombreArchivo: ['', [Validators.required]],
      periodo: ['', [Validators.required]],
     
    });


}

  ngOnInit(): void {

    this.getClienteById()
    this.getCentrosByCliente()
 
  }


  openDialog() {
    this.dialog.open(AltaContratistaComponent);
  }

  selectPeriodo(e:any){
    switch (e) {
      case 'Mensual':
        this.caducidad = 'Mensual'
        break;
      case 'Trimestral':
        this.caducidad = 'Trimestral'
        break;
      case 'Semestral':
        this.caducidad = 'Semestral'
        break;
      case 'Anual':
        this.caducidad = 'Anual'
        break;
      case 'No Caduca':
        this.caducidad = 'No caduca'
          break;
      default:
        break;
    }
    
  }

 

  openDialogNewCentro() {
    this.dialog.open(SolicitudCentrosComponent);
  }

  addDocAdicional(nombre:any){
    this.apollo.mutate({
      mutation: this.docAdicionalService.addDocumento(),
      variables: {
        "input": {
          "data": {
            "nombreArchivo": nombre,
            "cliente": this.userLog.cliente.id,
            "periocidad": this.caducidad,
            "firstTime": true,
            "numArchivo": this.numArchivo
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("ADD Ok", data, errors)
        location.reload()
      }, (error) => {
        console.log('error',error)
      })
  }

  deleteDocumentoById(id: String){
    this.apollo.mutate({
      mutation: this.docAdicionalService.deleteDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id
          },
        }
      }
    })
      .subscribe(({data}) => {
        console.log('BORRADO', data)
      }, (error) => {
        console.log(error)
      })
  }

  getClienteById(){
    this.apollo.watchQuery<any>({
      query: this.clienteService.getClienteById(),
      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        this.cliente = data.cliente
        
       this.docAdicional = data.cliente.documentos_adicionals;
       console.log(data.cliente.documentos_adicionals);
       
       this.docFirstTime = data.cliente.documentos_adicionals.filter((doc:any)=>doc.firstTime == true)
       
         if (this.docFirstTime[0]?.numArchivo == undefined) {
           this.numArchivo = 1
         }else{
           this.numArchivo = this.docFirstTime[this.docFirstTime.length -1].numArchivo + 1
         }
         
       
       
       
        data.cliente.centros.forEach((centro:any) => {
          if(centro.contratista.contactoResponsable?.mail != null) this.mailContratista.push(centro.contratista.contactoResponsable.mail)
        
      });
      this.mailContratista = [...new Set(this.mailContratista)]
       
          
      })
  }

  handleClickSolicitar() {
    const options = {
      text:"¿Está seguro que desea solicitar estos documentos a sus centros?",
      cancelText: 'Cancelar',
      confirmText: 'Solicitar'
    };
    this.confirmacionService.open(options);

    this.confirmacionService.confirmed().subscribe(confirmed => {
      /* console.log("doc adic", this.docAdicional);
      console.log("doc fist", this.docFirstTime);
       */
      if (confirmed) {
        for (let i = 0; i < this.docFirstTime.length; i++) {
          this.updateDocumentoAdicional(this.docFirstTime[i].id)
          
        }
        for (let i = 0; i < this.mailContratista.length; i++) {
          const templateContratista = `
                <!DOCTYPE html>
                <html>
                <head>
                <title></title>
                </head>

                <body>
                <img src='https://bucket-documentos-strapi.s3.eu-west-1.amazonaws.com/NUEVOS_REQUERIMIENTOS_78dd3e0ebf.png' style="width:500px; height:340px; display:block;
                margin:auto;">
                <div style="width:500px; margin:auto">
                <p>Estimado ${this.mailContratista[i]}</p>
                <p>Su cliente ${this.cliente.razonSocial} tiene nuevos requerimientos documentales para sus centros productores.</p>
                
                </body>
                </html>`;

                  this.mailService.send(
                    this.mailContratista[i],
                    'Nuevos Requerimientos Documentales',
                    templateContratista
                  );

          
        }
        
      }
    });
  }

  handleClickDelete(id:any) {
    const options = {
      text:"¿Está seguro que desea eliminar este documento?",
      cancelText: 'Cancelar',
      confirmText: 'Eliminar'
    };
    this.confirmacionService.open(options);

    this.confirmacionService.confirmed().subscribe(confirmed => {
      if (confirmed) {
        this.deleteDocumentoById(id)
        setTimeout(() => {
          location.reload()
        }, 500);
       
        
      }
    });
  }

  getCentrosByCliente() {
    this.apollo.watchQuery<any>({
      query: this.clienteService.getCentrosByCliente(),

      variables: {
        "id": this.userLog.cliente.id
      }
    })
      .valueChanges
      .subscribe(({data, loading, errors}) => {
        data.cliente.centros.forEach((centro:any) => {
          this.centrosCliente.push(centro.id)
        }); 
        
      })
  }

  updateDocumentoAdicional(id: string){
    console.log(this.centrosCliente);
    
    this.apollo.mutate({
      mutation: this.docAdicionalService.updateDocumentoById(),
      variables: {
        "input": {
          "where": {
            "id": id,
          },
          "data": {
            "centros": this.centrosCliente,
            
          }
        }    
      }
    })
      .subscribe(({data, errors}) => {
        console.log("EDITADO", data)
      }, (error) => {
        console.log('aaaaa',error)
      })
  }



}
